module.exports = __webpack_public_path__ + "static/media/literacy mission_accident.3a16f8be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/literacy mission_accident.gif
// module id = 364
// module chunks = 0